var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c6d0d7",
    d: "m13.707 6.16-.9-1.053a1.5 1.5 0 0 1-.307-.84V3.133c0-.706-.58-1.286-1.287-1.286H10.08a1.54 1.54 0 0 1-.847-.307L8.18.64C7.72.247 6.967.247 6.507.64l-1.067.9a1.5 1.5 0 0 1-.84.307H3.447c-.707 0-1.287.58-1.287 1.286v1.134c0 .26-.133.633-.3.833l-.9 1.06c-.387.467-.387 1.213 0 1.667l.9 1.06c.167.193.3.573.3.833v1.14c0 .707.58 1.287 1.287 1.287h1.16c.26 0 .64.14.84.306l1.053.9c.46.394 1.213.394 1.673 0l1.054-.9c.2-.166.573-.306.84-.306H11.2c.707 0 1.287-.58 1.287-1.287V9.727c0-.267.14-.64.306-.84l.9-1.054c.407-.453.407-1.206.014-1.673M6.833 4.42c0-.273.227-.5.5-.5.274 0 .5.227.5.5v3.22c0 .273-.226.5-.5.5a.504.504 0 0 1-.5-.5zm.5 5.827a.67.67 0 0 1-.666-.667c0-.367.293-.667.666-.667.367 0 .667.3.667.667a.664.664 0 0 1-.667.667"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4108e97c3d53a13ceacbb3d3d21b51ac.svg";
export { ForwardRef as ReactComponent };